import { render, staticRenderFns } from "./FieldDistribution.vue?vue&type=template&id=2b57b7f4&scoped=true"
import script from "./FieldDistribution.vue?vue&type=script&lang=js"
export * from "./FieldDistribution.vue?vue&type=script&lang=js"
import style0 from "./FieldDistribution.vue?vue&type=style&index=0&id=2b57b7f4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b57b7f4",
  null
  
)

export default component.exports